const plotFunctions = {};
export default plotFunctions;
